import request from '../utils/request';

export const getActivitiesService = (params = null) => {
  if (params === null) {
    return async dispatch => {
      const response = await dispatch(
        request('/activities', {
          method: 'GET',
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    const response = await dispatch(
      request('/activities', {
        method: 'GET',
        params,
      }),
    );
    return response;
  };
};

export const getAuditTrailService = (params = null) => {
  return async dispatch => {
    const response = await dispatch(
      request('/activities/audit', {
        method: 'GET',
        params,
      }),
    );
    return response;
  };
};
